// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorDialog_error__1VvLr"};